import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { CreateDrtIntegrationDto, DrtIntegration } from '../model/types';

export const createDrtIntegration = async (
  data: CreateDrtIntegrationDto,
): Promise<DrtIntegration> => {
  const response = await baseAPI.post<DrtIntegration>(
    '/api/admin/drt/integrations',
    data,
  );
  return response.data;
};

export const useCreateDrtIntegration = () => {
  return useMutation({
    mutationFn: createDrtIntegration,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.DRT_INTEGRATIONS],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      const errorMessage =
        error.response?.data.message ?? 'Failed to generate DRT integration.';
      toast.error(errorMessage);
      console.error('Failed to generate DRT integration.', error);
    },
  });
};
